import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../button/button'
import StyledInput from '../input'
import './continueGame.scss'
import { getRecentGames } from '../../utils/recentGames'
import Modal from '../modal'

const StyledModal = styled(Modal)`
    width: 100%;
`

export class ContinueGame extends Component {
    constructor (props) {
        super(props)

        this.state = { gameId: '' }
        this.recentGames = getRecentGames()
    }

    onKeyDown(e) {
        const { history } = this.props
        const { gameId } = this.state
        if (!gameId) {
            return
        }
        if (e.key !== 'Enter') {
            return
        }
        if (gameId === 'error') {
            throw new Error('Testing Error')
        }
        history.push(`/game/${gameId}`)
    }

    render() {
        const { gameId } = this.state
        return (
            <StyledModal
                title='Continue Game'>
                <div className='ContinueGame'>
                    <StyledInput
                        placeholder='Enter Game ID'
                        type='text'
                        onKeyDown={e => this.onKeyDown(e)}
                        onChange={e => this.setState({ gameId: e.target.value })} />
                    <br />
                    <Button text='Continue game' to={`/game/${gameId}`} />
                    <br />
                    {this.recentGames.length > 0 && (
                        <React.Fragment>
                            <h2>Recent Games</h2>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Short ID</th>
                                        <th>Title</th>
                                        <th>Last Played</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.recentGames.map(game => (
                                        <tr key={`recent-${game.short_id}`}>
                                            <td>
                                                <a href={`/game/${game.short_id}`}>
                                                    {game.short_id}
                                                </a>
                                            </td>
                                            <td>
                                                <a href={`/game/${game.short_id}`}>
                                                    {game.title || 'Untitled'}
                                                </a>
                                            </td>
                                            <td>{new Date(game.last_played_at).toLocaleString()}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </React.Fragment>
                    )}
                </div>        
            </StyledModal>

        )
    }
}

export default ContinueGame
